import { AxiosResponse } from 'axios';

import { messages } from '@qality/common-messages';
import {
  TestCaseInCycle,
  TestCycle,
  TestCycleProject,
} from '@qality/common-model';
import {
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

import FlagService from './FlagService';

export default {
  async createTestCycle(
    name: string,
    projectId: string,
    versionId: string | number,
    comment: string,
    dueDate: string
  ): Promise<AxiosResponse<TestCycle>> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_CYCLES
    );
    const requestData = {
      name,
      versionId,
      dueDate,
      projectId,
      comment,
    };
    return axios.post(url, requestData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  async cloneTestCycle(id: number): Promise<AxiosResponse> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_CYCLES +
        `/${id}/clone`
    );

    const response = await axios.post(url, null, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    FlagService.createSuccessFlag(
      'Success',
      messages['testCycle.clone.success']
    );

    return response;
  },

  async deleteTestCycle(testCycleId: number): Promise<AxiosResponse> {
    const link =
      StorageOfUniqueServices.get('APIConstants').URL_TEST_CYCLES +
      `/${testCycleId}`;
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin + link
    );
    return axios.delete(url);
  },

  async removeTestCaseFromCycle(
    testCase: TestCaseInCycle,
    testCycleId: number
  ): Promise<AxiosResponse> {
    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants').URL_TEST_CYCLES +
        `/${testCycleId}/testCycleAssignments/${testCase.id}`
    );
    return axios.delete(url);
  },

  async updateTestCasesInCyclePositions(
    testCases: Array<TestCaseInCycle>,
    testCycleId: number
  ): Promise<void> {
    const testCasesPayload = {
      testCases: testCases.map((testCase) => {
        return {
          id: testCase.id,
          position: testCase.position,
        };
      }),
      testCycleId,
    };

    const url = await StorageOfUniqueServices.get(
      'AuthenticateService'
    ).authenticateByJWT(
      StorageOfUniqueServices.get('WindowOriginService').origin +
        StorageOfUniqueServices.get('APIConstants')
          .URL_TEST_CASES_IN_CYCLE_POSITION
    );

    await axios.put(url, testCasesPayload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  navigateToTestExecutionReportOfCycle(
    testCycleId: number,
    project: TestCycleProject
  ): void {
    window.open(
      StorageOfUniqueServices.get('URLService').getTestExecutionReportUrl(
        testCycleId,
        project
      ),
      '_blank'
    );
  },
};
